import React from 'react';
import ReactDOM from 'react-dom/client';
import './css/index.css';
import App from './App';
import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';

import * as fi from './translations/fi';
import * as en from './translations/en';
import * as swe from './translations/swe';
import { siteLang } from './utils/variables';

i18next
  .use(initReactI18next) // pass i18next down to react-i18next
  .init({
    lng: siteLang, // Site language
    // Load resourses from translations folder inside src
    resources: {
      en: {
        countryData: en.countryData,
        filters: en.filters,
        mapList: en.mapList
      },
      fi: {
        countryData:fi.countryData,
        filters: fi.filters,
        mapList: fi.mapList
      },
      swe: {
        countryData:swe.countryData,
        filters: swe.filters,
        mapList: swe.mapList
      }
    }
  });
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
